module.exports = __webpack_public_path__ + "img/tgz.d9328f2a.png";